import { useCallback, useRef, useState } from "react";

/**
 * Runs one async action at a time. A consecutive call made while an action is already running
 * is ignored.
 *
 * Example usage: double click or a repeated key press won't send the same request twice.
 */
export const useLockedAction = () => {
  const isLockedRef = useRef(false);
  const [isLocked, setIsLocked] = useState(false);

  const run = useCallback(async (action: () => Promise<void>) => {
    if (isLockedRef.current) {
      return;
    }

    isLockedRef.current = true;
    setIsLocked(true);

    try {
      await action();
    } finally {
      isLockedRef.current = false;
      setIsLocked(false);
    }
  }, []);

  return { isLocked, run };
};
